import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Badge } from '../ui/badge';
import { Mail, Phone, Shield, Save } from 'lucide-react';

const IntegrationsTab = ({ onboardingStatus, settings, saveSettings }) => (
  <Card>
    <CardHeader><CardTitle>Integrations</CardTitle><CardDescription>Connected external services</CardDescription></CardHeader>
    <CardContent className="space-y-4">
      <div className="flex items-center justify-between p-4 border rounded-lg">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center"><Mail className="h-6 w-6 text-red-600" /></div>
          <div><p className="font-medium">Google (Gmail + Calendar)</p><p className="text-sm text-[#666666]">Send emails and sync interviews to Google Calendar</p></div>
        </div>
        <Badge className={onboardingStatus?.gmail_connected ? "bg-green-100 text-green-800" : "bg-yellow-100 text-yellow-800"}>{onboardingStatus?.gmail_connected ? "CONNECTED" : "NOT CONNECTED"}</Badge>
      </div>
      <div className="flex items-center justify-between p-4 border rounded-lg">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center"><Phone className="h-6 w-6 text-blue-600" /></div>
          <div><p className="font-medium">Twilio SMS</p><p className="text-sm text-[#666666]">Send and receive text messages</p></div>
        </div>
        <Badge className="bg-green-100 text-green-800">CONNECTED</Badge>
      </div>
      <div className="p-4 border rounded-lg space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center"><Shield className="h-6 w-6 text-purple-600" /></div>
            <div><p className="font-medium">Checkr Background Checks</p><p className="text-sm text-[#666666]">Automated background check processing</p></div>
          </div>
          <Badge className={settings?.checkr_api_key ? "bg-green-100 text-green-800" : "bg-yellow-100 text-yellow-800"}>{settings?.checkr_api_key ? "CONNECTED" : "NOT CONNECTED"}</Badge>
        </div>
        <div className="flex items-center gap-2">
          <Input type="password" placeholder="Enter your Checkr API key" value={settings?.checkr_api_key || ''} onChange={(e) => {}} className="flex-1" data-testid="checkr-api-key-input" />
          <Button onClick={() => saveSettings()} className="bg-[#4B2D6E] hover:bg-[#3A1F5E]" data-testid="save-checkr-key-btn"><Save className="mr-2 h-4 w-4" /> Save</Button>
        </div>
        <p className="text-xs text-[#999]">Find your API key in your Checkr Dashboard → Account Settings → Developer Settings</p>
      </div>
    </CardContent>
  </Card>
);

export { IntegrationsTab };
